import { SWRConfiguration } from 'swr';

import { CollaborationWorkList } from '~/data/collaboration/types';
import { useArraySWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

const getCollaborationWorkLists = async (
  language?: string,
  format?: string,
  includeAll?: boolean,
): Promise<CollaborationWorkList[]> => {
  const resolveParams = (): string => {
    let params: string[] = [];

    if (!!format) {
      params.push(`format=${format}`);
    }

    if (!!language) {
      params.push(`langIso=${language}`);
    }

    if (typeof includeAll !== 'undefined') {
      params.push(`includeAll=${includeAll}`);
    }

    return params.length > 0 ? `?${params.join('&')}` : '';
  };

  return fetchFromOldApi(`/json/collab/template${resolveParams()}`).then((r) =>
    r.json(),
  );
};

export const useGetCollaborationWorkLists = (
  props: {
    language?: string;
    format?: string;
    includeAll?: boolean;
  },
  swrConfig?: SWRConfiguration,
  isDisabled?: boolean,
) => {
  const { language, format, includeAll } = props;

  return useArraySWR(
    !isDisabled
      ? ['getCollaborationWorkLists', language, format, includeAll]
      : null,
    ([_, language, format, includeAll]: [
      string,
      string | undefined,
      string | undefined,
      boolean | undefined,
    ]) => getCollaborationWorkLists(language, format, includeAll),
    swrConfig,
  );
};
